import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateWagentRoutes = defineRoute({
    update: {
        route: {
            path: "/associate-wagent",
            component: () => loadView(import("./AssociateWagent.vue")),
        },
    },
});
